import { render } from "./courseContentModal.vue?vue&type=template&id=b7c54a76&ts=true"
import script from "./courseContentModal.vue?vue&type=script&lang=ts"
export * from "./courseContentModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__